var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('layout-vertical',{attrs:{"nav-menu-items":_vm.navMenuItems}},[_c('router-view'),(_vm.showCustomizer)?_c('app-customizer',{attrs:{"slot":"customizer"},slot:"customizer"}):_vm._e()],1),_c('loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }